import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import useInvoiceForm from "hooks/invoice/useInvoiceForm";
var InvoiceFormContext = /*#__PURE__*/ createContext(undefined);
export var InvoiceFormProvider = function(param) {
    var children = param.children;
    var contextValue = useInvoiceForm();
    return /*#__PURE__*/ _jsx(InvoiceFormContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var useInvoiceFormContext = function() {
    var context = useContext(InvoiceFormContext);
    if (!context) {
        throw new Error("useInvoiceFormContext must be used within an InvoiceFormProvider");
    }
    return context;
};
